import { FormControl, InputAdornment } from "@mui/material";
import TextField from "@mui/material/TextField";
import { Search } from "lucide-react";
import React from "react";
import { InputProps } from "./InputProps";
import { fontSizes, colors } from "../../theme";
import { useApi } from "../../contexts/ApiContext";
interface SearchTextInputProps extends InputProps {}

const SearchTextInput: React.FC<SearchTextInputProps> = ({
  label,
  value,
  onChange,
  error,
  helperText,
  ...rest
}) => {
  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  return (
    <FormControl fullWidth disabled={isDisabled}>
      <TextField
        sx={{ fontSize: fontSizes.sm }}
        {...rest}
        disabled={isDisabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search color="rgba(0, 0, 0, 0.54)" />
            </InputAdornment>
          ),
        }}
        variant="outlined"
        fullWidth
        type={"text"}
        value={value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.currentTarget.value)
        }
      />
    </FormControl>
  );
};

export default SearchTextInput;
